<template>
  <base-page-layout title="WhatsApp" :show-tour="!isExternalWhatsappProvider" :flow-id="flowId">
    <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-4" />
    <home v-if="tabs[tab].component === 'home'" />
    <status v-else-if="tabs[tab].component === 'status'" />
    <configuracoes-simples v-else-if="tabs[tab].component === 'configurations'" />
    <external-provider-configurations v-else-if="tabs[tab].component === 'external-provider-configurations'" />
    <flows v-else-if="tabs[tab].component === 'flows'" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import Home from '@/modules/campanhas/whatsapp/views/pages/WhatsappHome.vue'
import Flows from '@/modules/campanhas/whatsapp/views/pages/Flows.vue'
import Status from '@/modules/campanhas/whatsapp/views/pages/WhatsappStatus.vue'
import ConfiguracoesSimples from '@/modules/campanhas/whatsapp/views/pages/WhatsappConfiguracoesSimples.vue'
import ExternalProviderConfigurations from '@/modules/campanhas/whatsapp/views/pages/ExternalProviderConfigurations.vue'

export default {
  components: {
    BasePageLayout,
    Home,
    Status,
    Flows,
    ConfiguracoesSimples,
    ExternalProviderConfigurations,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    isExternalWhatsappProvider() {
      return this.$getAllowedModules()['external_whatsapp_provider']
    },
    flowId() {
      const outsideFlowTabUserflowId = 'b7b2c2ef-9bff-410c-a733-53e3f525dfc6'
      const insideFlowTabUserflowId = 'a6d6a322-c662-45f8-8de4-64e91a12c2f2'

      return this.tabs[this.tab].component === 'flows' ? insideFlowTabUserflowId : outsideFlowTabUserflowId
    },
    tabs() {
      if (this.isExternalWhatsappProvider) {
        return [
          {
            name: 'Home',
            component: 'home',
            haveLength: false,
          },
          {
            name: 'Configurações',
            component: 'external-provider-configurations',
            haveLength: false,
          },
        ]
      } else {
        return [
          {
            name: 'Home',
            component: 'home',
            haveLength: false,
          },
          {
            name: 'Status',
            component: 'status',
            haveLength: false,
          },
          {
            name: 'Configurações',
            component: 'configurations',
            haveLength: false,
          },
          {
            name: 'Fluxos',
            component: 'flows',
            haveLength: false,
          },
        ]
      }
    },
  },
  watch: {
    tab(newVal) {
      this.putTabOnUrl(String(newVal))
    },
  },
  mounted() {
    this.$bus.$on('userflow-update-tab', () => {
      this.tab = 3
    })
    if (!this.$route.query.tab) {
      this.putTabOnUrl('0')
    } else {
      this.tab = parseInt(this.$route.query.tab)
    }
  },
  destroyed() {
    this.$bus.$off('userflow-update-tab')
  },
  methods: {
    putTabOnUrl(tab) {
      this.$router.push({ query: { tab: tab } }).catch(() => {})
    },
  },
}
</script>
